// extracted by mini-css-extract-plugin
export var button = "_ej-4";
export var hasDarkBackground = "_ej-7";
export var hasLightBackground = "_ej-6";
export var iconWrapper = "_ej-0";
export var large = "_ej-2";
export var medium = "_ej-1";
export var small = "_ej-5";
export var xsmall = "_ej-3";